import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
// import { storage } from '../../firebase';
import apiClient from "../../../helpers/apiClient";
import InspectionSection from "./InspectionSection";

const styles = {
    container: {
        padding: "20px",
        fontFamily: "Arial, sans-serif",
    },
    title: {
        fontSize: "18px",
        fontWeight: "700",
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(6, 1fr)",
        gap: "2rem",
    },
    imageContainer: {
        position: "relative",
        width: "100%",
        height: "35vh",
        overflow: "hidden",
        borderRadius: "30px",
        backgroundColor: "#fff",
    },
    image: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
    },
    addButton: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "35vh",
        backgroundColor: "#fff",
        boxShadow: "0px 8px 20px 0px rgba(0, 0, 0, 0.08)",
        borderRadius: "10px",
        cursor: "pointer",
    },
    notes: {
        marginTop: "10px",
        fontSize: "14px",
        color: "#666",
    },
    editButton: {
        border: "1px solid #5D5DFF",
        cursor: "pointer",
        padding: "0.3rem 1rem",
        fontSize: "14px",
        fontWeight: "600",
        borderRadius: "5px",
        color: "#5D5DFF",
    },
    deleteButton: {
        position: "absolute",
        bottom: "2rem",
        right: "2rem",
        background: "red",
        color: "white",
        border: "none",
        borderRadius: "20%",
        fontSize: "2rem",
        padding: "4px",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    editActions: {
        display: "flex",
        alignItems: "center",
        gap: "0.8rem",
        cursor: "pointer",
    },
    btnDisabled: {
        cursor: "not-allowed",
        opacity: "0.6",
    },
    btnHover: {
        border: "1px solid #22226b",
    },
    loadingOverlay: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        zIndex: 1,
    },
    spinner: {
        border: "4px solid #f3f3f3",
        borderTop: "4px solid #3498db",
        borderRadius: "50%",
        width: "30px",
        height: "30px",
        animation: "spin 1s linear infinite",
    },
};

const displayTitles = {
    checkDamages: "Scratches, Dents, or Damages",
    checkWipers: "Check Wipers",
    checkElectronics: "Check Electronics",
    checkFuelLevel: "Check Fuel Level",
    checkMissingAccessories: "Check Missing Accessories",
    checkWarningLights: "Check Warning Lights",
    verifyTireCondition: "Verify Tire Condition",
};

const InspectionDetails = ({ data, allData, fetchCleanerStatus }) => {
    const { id } = useParams();
    const [inspectionData, setInspectionData] = useState({});
    const [, setLoading] = useState(false);
    // const [editStates, setEditStates] = useState({});

    useEffect(() => {
        const initialData = data.values || data || {};
        setInspectionData(initialData);
        // Initialize edit states for future use
        // setEditStates(
        //     Object.keys(initialData).reduce((acc, key) => {
        //         acc[key] = false;
        //         return acc;
        //     }, {}),
        // );
    }, [data]);

    const updateInspection = useCallback(
        async (field, updatedData) => {
            setLoading(true);
            try {
                const response = await apiClient.patch(`/api/cleaner-status/${id}`, updatedData);
                if (response.data.message) {
                    fetchCleanerStatus();
                    setLoading(false);
                }
            } catch (error) {
                // console.error("Error updating:", error);
            } finally {
                setLoading(false);
            }
        },
        [id, fetchCleanerStatus],
    );

    return (
        <div style={styles.container}>
            {Object.entries(inspectionData).length === 0 ? (
                <p>No inspection data available.</p>
            ) : (
                Object.entries(inspectionData)?.map(([field, item]) => (
                    <InspectionSection
                        key={field}
                        field={field}
                        inspectionItem={item}
                        title={displayTitles[field] || field}
                        updateInspection={updateInspection}
                        allData={allData}
                    />
                ))
            )}
        </div>
    );
};

InspectionDetails.propTypes = {
    data: PropTypes.oneOfType([
        PropTypes.shape({
            values: PropTypes.object,
        }),
        PropTypes.object,
    ]).isRequired,
    allData: PropTypes.object,
    fetchCleanerStatus: PropTypes.func.isRequired,
};

export default InspectionDetails;
